import { inject, Injectable, InjectionToken } from '@angular/core';
import { environment } from '../../../../environments/environment';

export const CT_KWH_TO_EUR_MWH_FACTOR = new InjectionToken<number>('ctKwhToEurMwhFactor', {
  providedIn: 'root',
  factory: () => environment.analysis.price.ctKwhToEurMwhFactor,
});

@Injectable({
  providedIn: 'root',
})
export class PriceConversionService {
  private factor: number;

  constructor() {
    let injectedFactor: number | null = null;
    try {
      injectedFactor = inject(CT_KWH_TO_EUR_MWH_FACTOR, { optional: true });
    } catch {
      // Fallback if instantiated outside Angular injection context
    }
    this.factor = injectedFactor ?? environment.analysis.price.ctKwhToEurMwhFactor;
  }

  convertPrice(value: number, showEurMwh: boolean): number;
  convertPrice(value: number | undefined | null, showEurMwh: boolean): number | undefined | null;
  convertPrice(value: number | undefined | null, showEurMwh: boolean): number | undefined | null {
    if (value === undefined || value === null) {
      return value;
    }
    return showEurMwh ? value * this.factor : value;
  }
}
